import type { ComponentType } from 'react';
import type { ICampaignInfo, ICampaignCardMap, CampaignTypes, CampaignSource } from '../types/campaign.types';
import PrizePopCard from '../components/variants/prizePop/PrizePopCard/PrizePopCard';
import TournamentCard from '../components/variants/tournaments/TournamentCard/TournamentCard';
import RebateCard from '../components/variants/rebate/RebateCard/RebateCard';
import { CampaignDataService } from './campaignDataService';

const componentCampaignMap: ICampaignCardMap = {
  CAMPAIGN_TOURNAMENTS_CARD_INFO: TournamentCard as ComponentType<Omit<ICampaignInfo, 'component'>>,
  CAMPAIGN_PRIZE_POP_CARD_INFO: PrizePopCard as ComponentType<Omit<ICampaignInfo, 'component'>>,
  CAMPAIGN_REBATE_CARD_INFO: RebateCard as ComponentType<Omit<ICampaignInfo, 'component'>>,
};

const getCampaignComponent = (campaignType: CampaignTypes): ComponentType<Omit<ICampaignInfo, 'component'>> => {
  const cardKey = `CAMPAIGN_${campaignType.toUpperCase()}_CARD_INFO` as keyof ICampaignCardMap;
  return componentCampaignMap[cardKey];
};

const createCampaignInfo = (data: CampaignSource, campaignType: CampaignTypes): ICampaignInfo => {
  const basicData = CampaignDataService.getBasicData(data);
  const component = getCampaignComponent(campaignType);

  return {
    ...basicData,
    component,
    type: campaignType,
  };
};

export const campaignMapper = (campaignType: CampaignTypes, items?: CampaignSource[]) => {
  const data = CampaignDataService.getFirstCampaign(campaignType, items);
  
  if (!data) {
    return null;
  }

  const campaignInfo = createCampaignInfo(data, campaignType);
  const campaignData = CampaignDataService.getCampaignData(data);

  if (campaignData) {
    return {
      id: data.id,
      status: data.status,
      campaignInfo: {
        ...campaignInfo,
        terms: campaignData.terms,
        level: campaignData.level,
        joined: campaignData.joined,
        ...('joinedPlayersCount' in campaignData ? { joinedPlayersCount: campaignData.joinedPlayersCount } : {}),
      },
    };
  }

  return {
    id: data.id,
    status: data.status,
    campaignInfo,
  };
};
